import React from 'react';
import { useQuery } from '@apollo/client';
import { GET_ACTIVE_PROMOTION } from '@shared/graphql/queries/promotions';
import { LandingHero } from '../components/home';
import { LoginPrompt } from '../components/ui';

/** TippingIQ's landing for signed-out visitors on the home route (BrandConfig.loggedOutHome). */
const LoggedOutHome: React.FC = () => {
  const { data, loading } = useQuery(GET_ACTIVE_PROMOTION, { errorPolicy: 'all' });
  return (
    <>
      <LandingHero promotionData={data} promotionLoading={loading} />
      {/* The server-built racing-tips pages (docs/plans/seo-public-pages.md): a plain link, outside the app's router. */}
      <p className="mx-auto max-w-4xl px-4 py-4 text-center text-gray-700">
        Not ready to sign up? See <a className="font-semibold text-green-700 underline" href="/horse-racing-tips">our horse racing tips and results</a> from every past day, free.
      </p>
      <LoginPrompt message="Join today for free daily best bets and access to premium subscription packages with comprehensive racing analysis." />
    </>
  );
};

export default LoggedOutHome;
